import styled from 'styled-components';

export const NewLogoHpPlus = styled('img')`
  height: ${props => props.height};
  width: ${props => props.width};
`;
export default { NewLogoHpPlus };
